import { format } from 'date-fns';
import { FiFile, FiImage, FiVideo } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useUpdates } from "../../contexts/updatesContext";

const getUploadIcon = (type) => {
  switch(type) {
    case 'sermon':
    case 'video':
      return <FiVideo className="text-blue-500" />;
    case 'image':
    case 'thumbnail':
      return <FiImage className="text-green-500" />;
    default:
      return <FiFile className="text-gray-500" />;
  }
};

const RecentUploads = () => {
  const { updates } = useUpdates();
  const recentUploads = updates?.slice(0, 5) || [];

  if (!recentUploads.length) {
    return (
      <div className="bg-white p-6 rounded-xl shadow-sm">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">
          Recent Uploads
        </h3>
        <p className="text-gray-500">No recent uploads found</p>
      </div>
    );
  }

  return (
    <Link className="bg-white p-6 rounded-xl shadow-sm" to="/admin/updates">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        Recent Uploads
      </h3>
      <div className="space-y-4">
        {recentUploads.map((upload) => (
          <div key={upload.id} className="flex items-start pb-4 border-b border-gray-100">
            <div className="mr-3 mt-1">
              {getUploadIcon(upload.type)}
            </div>
            <div className="flex-1">
              <p className="font-medium text-gray-800">
                {upload.title}
              </p>
              <div className="flex flex-wrap items-center gap-2 text-sm text-gray-500">
                <span>{upload.speaker || 'Unknown speaker'}</span>
                <span>•</span>
                <span>{format(new Date(upload.date), 'MMM d, yyyy')}</span>
                {upload.ministry && (
                  <>
                    <span>•</span>
                    <span className="bg-gray-100 px-2 py-0.5 rounded-full">
                      {upload.ministry}
                    </span>
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Link>
  );
};

export default RecentUploads;